import React, { createContext, useContext, useState, useEffect } from "react";

// Create a context to share tour state
const TourContext = createContext();

export const TourProvider = ({ children }) => {
  const [tourState, setTourState] = useState({
    enabled: true,
    currentStep: 0,
    showProfileStep: false,
  });

  return (
    <TourContext.Provider value={{ tourState, setTourState }}>
      {children}
    </TourContext.Provider>
  );
};
export const useTour = () => {
  return useContext(TourContext);
};
